import { render, staticRenderFns } from "./MainDashboardCard.vue?vue&type=template&id=2f143cb1&scoped=true&"
import script from "./MainDashboardCard.vue?vue&type=script&lang=js&"
export * from "./MainDashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./main-dashboard-card.scss?vue&type=style&index=0&id=2f143cb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f143cb1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VFlex,VIcon})
